export default function DrywallServices() {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: 'Drywall Installation',
      description: 'Professional installation of new drywall for residential and commercial projects with precise measurements and quality materials.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Drywall Repair',
      description: 'Expert repair services for holes, cracks, water damage, and structural issues with seamless matching to existing walls.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Texture & Finishing',
      description: 'Custom texture application including smooth, knockdown, orange peel, and specialty finishes for perfect wall surfaces.'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Drywall',
      description: 'Large-scale commercial drywall projects including offices, retail spaces, and industrial buildings with efficient timelines.'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Residential Drywall',
      description: 'Complete residential services from new construction to remodels, additions, and home renovations with attention to detail.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Water Damage Restoration',
      description: 'Comprehensive water damage repair including mold remediation, structural assessment, and complete drywall replacement.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Drywall Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From installation to repair and finishing, our contractors provide complete drywall solutions for every project type and size.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow border border-gray-200">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
